import { atom } from "recoil";
import { RankDto } from "../api/member";

export interface RankingCacheKey {
  type: string;
  pubFilterId: number;
  pubSeasonNum: number;
  companySeasonNum: number;
  year: number;
  month: number;
  week: number;
  filterType: string;
  userId: number;
}

export interface CachedRankingData {
  rankings: RankDto[];
  myRank: RankDto | null;
  total: number;
  lastUpdated: number;
}

export const createCacheKey = (params: RankingCacheKey): string => {
  return `${params.type}_${params.pubFilterId}_${params.pubSeasonNum}_${params.companySeasonNum}_${params.year}_${params.month}_${params.week}_${params.filterType}_${params.userId}`;
};

export const rankingCacheState = atom<Record<string, CachedRankingData>>({
  key: "rankingCacheState",
  default: {},
});
